// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {ImageSrc, Href} from 'docs/markdoc/attribute-types';

export const IntegrationCard: MarkdocTagRegistration = {
  tag: 'integration-card',
  component: 'IntegrationCard',
  attributes: {
    badge: {
      type: Object,
      required: false,
      localizable: true,
      description: 'A badge overlay on the top left of the card image',
    },
    text: {
      type: [Array, String],
      required: true,
      localizable: ['text', 'label'],
      description:
        'The body text of the card, can either be an string or a list of label and text in the format of [{label: "YOUR LABEL", text: "YOUR TEXT"}, ...]',
    },
    title: {
      type: String,
      required: true,
      localizable: true,
      description: 'Title of the card',
    },
    href: {
      type: Href,
      required: true,
      description: 'URL that clicking the card will take you to',
    },
    image: {
      type: ImageSrc,
      required: true,
      description:
        'Path to the images for the image displayed at the top of the card',
    },
    effort: {
      type: Number,
      required: false,
      description:
        'The effort level caption, below the body text of the card, ranging from number 1 (easiest) to 5 (hard)',
    },
    effortColor: {
      type: String,
      required: false,
      description:
        'Config the color for effort level, will use the default color if this option is not set. Refer to https://sail.corp.stripe.com/index.html?path=/docs/components-icons-images-charticon--icons#colors for color options',
    },
    buttonLabel: {
      type: String,
      required: false,
      localizable: true,
      description:
        'Button label for the button below the body text of the card',
    },
    buttonHref: {
      type: String,
      required: false,
      description:
        'URL that clicking the button will take you to; if the button URL is not explicitly set, the card url will be used',
    },
    titleBadge: {
      type: Boolean,
      required: false,
      description:
        'display the badge next to the title instead of on the image',
    },
  },
};
